//hamburger
const toggleGlobalNav = () => {

  const hamburger = document.getElementById('js-hamburger');

  if (!hamburger) return;

  const body = document.body;

  hamburger.addEventListener('click', () => {
    body.classList.toggle('is-gnav-active');
  });
}
toggleGlobalNav();


import Swiper from 'swiper/bundle';

// import 'swiper/css/bundle';

// import '../node_modules/swiper/swiper-bundle';
// import '../../node_modules/swiper/swiper.min.css';



const worksSlider = new Swiper('.works-slider', {
  loop: true,
  centeredSlides: true,
  slidesPerView: "auto",
  spaceBetween: 16,
  observer: true,
  observeParents: true,
  autoplay: {
    delay: 2500,
  },
  breakpoints: {
    768: {
      spaceBetween: 24,
    },
    998: {
      spaceBetween: 42,
    }
  },
});

worksSlider();